import React, { useState, useEffect, useCallback } from 'react';
import '../Css/WorkHoursTable.css';
import { Link } from 'react-router-dom';
import Logger from './Logger';
import { Typography, CircularProgress } from '@mui/material';
import { FaListUl } from "react-icons/fa";
import { getLoggerBaseURL } from '../utils/getLoggerBaseURL';

const WorkHoursTable = ({ searchTerm = '', selectedDate = new Date() }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const userEmail = sessionStorage.getItem('userEmail');

  // Initialize Logger
  const logger = React.useMemo(() => new Logger(getLoggerBaseURL()), []);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      logger.log(`logged in user: ${userEmail}`, 'INFO');
      const response = await fetch(`/api/driver/${userEmail}`);

      if (!response.ok) {
        throw new Error('Failed to fetch data');
      }

      const responseData = await response.json();
      if (!responseData || responseData.length === 0) {
        logger.log('No data available', 'INFO');
        setData([]);
        setLoading(false);
        return;
      }

      const formattedData = responseData.map(item => {
        const start_time = item.onlineEvents.length > 0 ? new Date(item.onlineEvents[item.onlineEvents.length - 1]?.timestamp) : null;
        const end_time = item.offlineEvents.length > 0 ? new Date(item.offlineEvents[item.offlineEvents.length - 1]?.timestamp) : null;
        const work = item.workingHours[0]?.hours || 0;
        return {
          ...item,
          start_time,
          end_time,
          work
        };
      });
      setData(formattedData);
      setLoading(false);
    } catch (error) {
      logger.log(`Error fetching data: ${error.message}`, 'ERROR');
      setData([]);
      setLoading(false);
    }
  }, [userEmail, logger]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const filteredData = data.filter(item => {
    const itemDate = item.start_time ? item.start_time.toISOString().split('T')[0] : null;
    const selectedDateString = selectedDate.toISOString().split('T')[0];

    return (
      item.name?.toLowerCase().includes(searchTerm.toLowerCase()) && itemDate === selectedDateString
    );
  });

  return (
    <div>
      {loading ? (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80vh' }}>
          <CircularProgress />
          <Typography variant="h6" style={{ marginTop: '20px' }}>Fetching Data...</Typography>
        </div>
      ) : (
        <table className="Stb">
          <thead>
            <tr>
              <th className="Wth"><strong>Carrier Name</strong></th>
              <th className="Wth"><strong>Latest Start Time</strong></th>
              <th className="Wth"><strong>Latest End Time</strong></th>
              <th className="Wth"><strong>Hour(s) Worked</strong></th>
              <th className="Wthh"><strong>Report</strong></th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length === 0 ? (
              <tr>
                <td className="noOrders" colSpan="20">
                  <div className="center-content">
                    <div className="icon-wrapper">
                      <FaListUl className="icon" />
                    </div>
                    <span className="noOrdersMsg">No data available</span>
                  </div>
                </td>
              </tr>
            ) : (
              filteredData.map((item) => (
                <tr key={item._id}>
                  <td className="Wtd">{item.name}</td>
                  <td className="Wtd">{item.start_time ? item.start_time.toLocaleString() : 'N/A'}</td>
                  <td className="Wtd">{item.end_time ? item.end_time.toLocaleString() : 'N/A'}</td>
                  <td className="Wtd">{item.work}</td>
                  <td>
                    {item.start_time ? (
                      <Link to={`/driverpdf/${item.email}/${item.start_time.toISOString().split('T')[0]}/${selectedDate.toISOString().split('T')[0]}`}>
                        <button className="bS">Report</button>
                      </Link>
                    ) : 'N/A'}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default WorkHoursTable;
